import type { ModuleFile } from '../../core/modules.ts';

// Módulo «privacy»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'privacy',
    title: 'Privacidad',
    path: 'privacidad',
    nav: { group: 'Sistema', label: 'Privacidad', icon: '⚿', order: 3 },
    load: () => import('./PrivacyPage.tsx').then((m) => ({ default: m.PrivacyPage })),
  },
];
